<template>
  <div id="layout-no-nav" class="container-fluid p-0">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
